<!--
component: Wards
author: Ken Nakamura
description: 区選択画面
-->
<template>
  <section class="wards">
    <div class="head-message">
      {{ headMessage }}
    </div>
    <v-container fluid>
      <v-row class="px-4">
        <v-col v-for="(ward,index) in wards" :key="index"
          v-show="ward.code>14100"
          cols="6" xs="6" sm="4" md="2" lg="2" xl="1">
          <v-btn color="#bbccaa" width="95%" x-large
            @click="selectWard(ward.code, ward.name)"
            class="text-sm-h5 py-9">
            {{ ward.name }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import constants from '../common/constants'
import { dbglog } from '../common/utils.js'

export default {
  data: () => ({
    wards: constants.Wards
  }),
  props: {
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
    this.$store.commit('setCurrentPage', 2);
    if (this.searchMode == 0) {
      this.message = '地名・地番検索：';
    }
    else if (this.searchMode == 1) {
      if (this.mode == 1) {
        this.message = '建築確認申請プロット地図検索';
      }
      else if (this.mode == 5 || this.mode == 6) {
        this.message = '開発・造成・土石の堆積プロット地図検索';
      }
      else {
        this.message = 'プロット地図検索';
      }
    }
    else {
      this.message = '区検索：';
    }
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    mode () {
      return this.$store.state.mode;
    },
    searchMode () {
      return this.$store.state.searchMode;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    headMessage() {
      //return '区名をタッチして下さい';
      return '区名を選択して下さい';
    }
  },
  methods: {
    selectWard (code, name) {
      if (this.searchMode == 0) {
        this.navigateTownPage(code, name);
      }
      else if (this.searchMode == 1) {
        this.$router.push({ name: 'select-plotindex', params: { ward: code } });
      }
    },
    navigateTownPage (code, name) {
      dbglog('Wards.navigateTownPage(' + code + ',' + name + ')');
      this.$store.commit('setTownTab', 'tab-a');
      this.$router.push({ name: 'towns', params: { ward: code } });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/common/common.css';

</style>